import { action, makeObservable, observable } from "mobx";
import bookCreatorProvider, { Page } from "./book-creator";

/**
 * 创建页面操作类
 */
class BookCreatorPageManager {
  public currentPage: Nullable<Page>;
  private get pages() {
    return bookCreatorProvider.pages;
  }
  constructor() {
    makeObservable(this, {
      currentPage: observable,
      handleFocusPage: action,
      handleSweep: action,
    });
  }
  public handleFocusPage(index: number) {
    const page = this.pages.find((p) => p.index === index);
    this.currentPage = page;
    console.log("设置", page);
  }
  handleDeleteCurrentPage() {
    if (!this.currentPage) {
      console.log("当前页面不存在");
      return;
    }
    bookCreatorProvider.handleDeletePage(this.currentPage);
    this.currentPage = null;
  }
  handleSweep() {
    this.currentPage = null;
  }
}

const bookCreatorPageManager = new BookCreatorPageManager();

export default bookCreatorPageManager;
